module.exports = __webpack_public_path__ + "img/speed-dial.f8ce761.svg";